import React, { useState, useEffect } from 'react';
import './Inicio.css'; // Tu archivo CSS principal
import ProyectosDestacados from '../Cards/ProyectosDestacados';

// --- Rutas de imágenes ---
import carouselImg1 from '../../uploads/presentacion/1.png';
import carouselImg2 from '../../uploads/presentacion/2.png';
import infoImg3 from '../../uploads/presentacion/3.png';
import infoImg4 from '../../uploads/presentacion/4.png';
import infoImg6 from '../../uploads/presentacion/6.png';

const carouselImages = [
    carouselImg1,
    carouselImg2
];

const Inicio = ({ navigateTo }) => {
    const [activeTab, setActiveTab] = useState('nosotros');
    const [isTimelineModalOpen, setIsTimelineModalOpen] = useState(false);
    const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
    const [currentTimelineSlide, setCurrentTimelineSlide] = useState(0);
    const [currentCarouselSlide, setCurrentCarouselSlide] = useState(0);

    useEffect(() => {
        const slideInterval = setInterval(() => {
            setCurrentCarouselSlide(prev => (prev === carouselImages.length - 1 ? 0 : prev + 1));
        }, 10000);
        return () => clearInterval(slideInterval);
    }, []);

    const nextCarouselSlide = () => {
        setCurrentCarouselSlide(prev => (prev === carouselImages.length - 1 ? 0 : prev + 1));
    };

    const prevCarouselSlide = () => {
        setCurrentCarouselSlide(prev => (prev === 0 ? carouselImages.length - 1 : prev - 1));
    };

    const goToCarouselSlide = (index) => {
        setCurrentCarouselSlide(index);
    };

    const timelineData = [
        { year: '1977', title: 'Creación', text: ['La trayectoria de R&Q mezcla lo mejor de dos tradiciones: la de una empresa forjada como una familia, junto al espíritu innovador que le ha permitido mantenerse a la vanguardia de la ingeniería chilena.', 'La compañía surge en 1977, bajo el mando de tres ingenieros: Bernardo Quiroga Vásquez, Jorge Homero Chávez Sánchez y Juan Rutllant Fernández. En una época en que la consultoría en ingeniería prácticamente no existía en Chile, R&Q se instaló como pionera.'] },
        { year: "80's", title: 'Crecimiento', text: ['A mediados de la década de los 80, inició un crecimiento sostenido, aportando en obras públicas y diversos proyectos de infraestructura.'] },
        { year: '1990', title: 'Ingeniería Multidisciplinaria', text: ['A comienzos de los 90, R&Q contaba con cerca de 100 colaboradores y aumentaba sus áreas de trabajo, convirtiéndose en una empresa de ingeniería multidisciplinaria, incorporando a sus servicios la ingeniería vial hasta proyectos hidráulicos, sanitarios, obras en aeropuertos y embalses, entre otros.'] },
        { year: '2000', title: 'Actor relevante', text: ['Tras este crecimiento, la meta fue ingresar a grandes proyectos y obras en minería. Es un objetivo cumplido con creces: actualmente, R&Q es un actor clave en los servicios de ingeniería para la minería en el país, llevando su experiencia en esta área incluso a mercados internacionales.'] },
        { year: 'HOY', title: 'Estándar de Excelencia', text: ['Hoy, con más de 2.400 colaboradores, el espíritu fundacional de R&Q sigue en alto como una empresa pionera, que mantiene el más alto estándar de excelencia en ingeniería, que otorga un valor primordial a la seguridad de sus trabajadores, y que busca permanentemente nuevos focos de crecimiento y desafíos.', 'La huella de R&Q está presente desde Arica a Magallanes: en sus caminos, carreteras, obras públicas e infraestructura privada. La compañía se despliega en el Puente Chacao, obra única en Latinoamérica; en el Metro de Santiago; y en infraestructura minera de gran envergadura, como lo es Chuquicamata Subterráneo, Collahuasi y Andina, por citar algunos ejemplos.', 'Gracias a su experiencia, R&Q ha comenzado un proceso de expansión internacional, abordando diversos proyectos fuera de Chile, destacando su participación en obras ubicadas en Colombia, Perú y México, entre otros países.'] }
    ];

    const nextTimelineSlide = () => setCurrentTimelineSlide((prev) => (prev === timelineData.length - 1 ? 0 : prev + 1));
    const prevTimelineSlide = () => setCurrentTimelineSlide((prev) => (prev === 0 ? timelineData.length - 1 : prev - 1));

    const renderTabContent = () => {
        switch (activeTab) {
            case 'nosotros':
                return (
                    <>
                        <h4>interventoría —</h4>
                        <p>La trayectoria de R&Q mezcla lo mejor de dos tradiciones: la de una empresa forjada como una familia, junto al espíritu innovador que le ha permitido mantenerse a la vanguardia de la ingeniería chilena.</p>
                        <button className="more-info-link" onClick={() => setIsTimelineModalOpen(true)}>→ Más información</button>
                    </>
                );
            case 'mision':
                return (
                    <>
                        <h2>Nuestra Misión</h2>
                        <p>Proveemos a cada segmento de clientes, servicios de ingeniería multidisciplinarios del más alto nivel, asegurándonos de entregar la mejor propuesta de valor a cada uno de nuestros proyectos, todo esto bajo una perspectiva sostenible. Estamos constantemente preocupados de retener y atraer a los mejores talentos como el principal activo de nuestra compañía, construyendo un futuro mejor para nuestros clientes, colaboradores y accionistas.</p>
                    </>
                );
            case 'vision':
                return (
                    <>
                        <h2>Nuestra Visión</h2>
                        <p>Ser la concesión vial líder en Colombia, reconocida por nuestra eficiencia, compromiso con el medio ambiente y por ser un motor clave en el desarrollo económico y social del país, conectando futuros.</p>
                    </>
                );
            default:
                return null;
        }
    };

    return (
        <div className="inicio-container">
            <section className="hero-section">
                <div
                    className="carousel-container"
                    style={{ transform: `translateX(-${currentCarouselSlide * 100}%)` }}
                >
                    {carouselImages.map((img, index) => (
                        <div
                            className="carousel-slide"
                            key={index}
                            style={{ backgroundImage: `url(${img})` }}
                        ></div>
                    ))}
                </div>
                <div className="hero-content">
                    <div className="hero-buttons">
                        <button onClick={() => navigateTo('proyectos')} className="hero-btn primary">Ver Proyecto</button>
                        <button onClick={() => navigateTo('contactos')} className="hero-btn secondary">Contáctanos</button>
                    </div>
                </div>
                <button className="carousel-nav prev" onClick={prevCarouselSlide}>‹</button>
                <button className="carousel-nav next" onClick={nextCarouselSlide}>›</button>
                <div className="carousel-indicators">
                    {carouselImages.map((_, index) => (
                        <button
                            key={index}
                            className={`indicator ${currentCarouselSlide === index ? 'active' : ''}`}
                            onClick={() => goToCarouselSlide(index)}
                        ></button>
                    ))}
                </div>
            </section>

            <section className="about-section">
                <div className="about-content-wrapper">
                    <div className="about-image">
                        <img src="https://www.mch.cl/wp-content/uploads/2023/09/RQ-foto-OK.jpg" alt="Equipo de ingenieros en proyecto" />
                        <div className="play-button-overlay" onClick={() => setIsVideoModalOpen(true)}>
                            <div className="play-button"></div>
                        </div>
                    </div>
                    <div className="about-text">
                        <div className="tabs">
                            <button className={`tab-button ${activeTab === 'nosotros' ? 'active' : ''}`} onClick={() => setActiveTab('nosotros')}>Nosotros</button>
                            <button className={`tab-button ${activeTab === 'mision' ? 'active' : ''}`} onClick={() => setActiveTab('mision')}>Misión</button>
                            <button className={`tab-button ${activeTab === 'vision' ? 'active' : ''}`} onClick={() => setActiveTab('vision')}>Visión</button>
                        </div>
                        <div className="tab-content">{renderTabContent()}</div>
                    </div>
                </div>
            </section>
            
            {/* --- ESTRUCTURA FINAL: TÍTULO ARRIBA, IMAGEN DEBAJO --- */}
            <section className="info-section">
                {/* --- ITEM 1 --- */}
                <div className="info-item">
                    <div className="info-title-wrapper">
                        <h3>Nuestra Trayectoria</h3>
                    </div>
                    <div className="info-image-wrapper">
                        <img src={infoImg4} alt="Nuestra Trayectoria y Expansión" />
                    </div>
                </div>

                {/* --- ITEM 2 --- */}
                <div className="info-item">
                    <div className="info-title-wrapper">
                        <h3>Servicios de Ingeniería</h3>
                    </div>
                    <div className="info-image-wrapper">
                        <img src={infoImg6} alt="Servicios de Ingeniería en Colombia" />
                    </div>
                </div>

                {/* --- ITEM 3 --- */}
                <div className="info-item">
                    <div className="info-title-wrapper">
                        <h3>Presencia en Colombia</h3>
                    </div>
                    <div className="info-image-wrapper">
                        <img src={infoImg3} alt="Sucursal y oficinas en Colombia" />
                    </div>
                </div>
            </section>

            <ProyectosDestacados />

            {/* --- MODAL DE LÍNEA DE TIEMPO CON CLASES ÚNICAS --- */}
            {isTimelineModalOpen && (
                <div className="timeline-modal-overlay" onClick={() => setIsTimelineModalOpen(false)}>
                    <div className="timeline-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="timeline-modal-close-button" onClick={() => setIsTimelineModalOpen(false)}>×</button>
                        <div className="timeline-slide">
                            <div className="timeline-year">{timelineData[currentTimelineSlide].year}</div>
                            <div className="timeline-details">
                                <h3>{timelineData[currentTimelineSlide].title}</h3>
                                {timelineData[currentTimelineSlide].text.map((p, i) => <p key={i}>{p}</p>)}
                            </div>
                        </div>
                        <button className="timeline-nav prev" onClick={prevTimelineSlide}>‹</button>
                        <button className="timeline-nav next" onClick={nextTimelineSlide}>›</button>
                    </div>
                </div>
            )}

             {/* --- MODAL DE VIDEO CON CLASES ÚNICAS --- */}
            {isVideoModalOpen && (
                <div className="video-modal-overlay" onClick={() => setIsVideoModalOpen(false)}>
                    <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="video-modal-close-button" onClick={() => setIsVideoModalOpen(false)}>×</button>
                        <div className="video-responsive-container">
                            <iframe
                                src="https://www.youtube.com/embed/UbNz0ZJSQh0?autoplay=1&rel=0"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                title="Video Institucional R&Q"
                            ></iframe>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
export default Inicio;